<template>
    <div class="page">
        <mt-header title="预约外卖查询">
            <mt-button icon="back"   slot="left" @click="closeqShop">返回</mt-button> 
        </mt-header>        
        <div class="page-content">
            <Takeout-Query></Takeout-Query>
        </div>
        <popup-full-picker
            v-if="results && results.length"
            :popupTypeText="popupTypeText"
            :showPicker="showPicker"
            :results="results"
            @popupHandle="popupHandle"
            @submitHandle="submitHandle"
        />         
    </div>
</template>
<script>
    import TakeoutQuery from "@/components/takeoutQuery"
    import PopupFullPicker from '@/components/popup-full-picker'
    import selectInfo from '@/components/selectInfo.js'
    import closeWebview from '@/components/closeWebview'
    export default {
        mixins: [selectInfo, closeWebview],
        data() {
            return {
                
            }
        },
        components: {
            TakeoutQuery,
            PopupFullPicker
        },
        methods: {
            closeqShop() {
                this.closeWebview()
            },            
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/takeoutQueryIndex.vue